var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import { IconButton } from '@doordash/component-button';
import Popover from '@doordash/component-popover';
import { Icon, Text, Inset } from '@doordash/design-language';
import ListCell from '@doordash/component-list-cell';
import { useToast } from '@doordash/component-toast';
import { RemovePaymentCardModal } from './modals/RemovePaymentCardModal';
import { useDeletePaymentCardMutation } from './useDeletePaymentCardMutation';
import { useSetDefaultPaymentCardMutation } from './useSetDefaultPaymentCardMutation';
import { PaymentCardTestId } from './testId';
import PaymentStrings from './PaymentStrings';
import track from '../../../utils/track';
import { BillingPaymentCardEvents } from '../../../constants/events';
export var ListCellContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 180px;\n"], ["\n  width: 180px;\n"])));
var Cell = function (_a) {
    var text = _a.text, disabled = _a.disabled, onClick = _a.onClick, hidePopOver = _a.hidePopOver, dataTestId = _a.dataTestId;
    var color = disabled ? Text.Colors.TextTertiary : Text.Colors.TextPrimary;
    return (React.createElement(ListCell, { accessibilityRole: "radio", title: React.createElement(Text, { color: color }, text), onClick: disabled
            ? null
            : function () {
                onClick && onClick();
                hidePopOver();
            }, "data-testid": dataTestId }));
};
var PaymentCardActionPopover = function (_a) {
    var cardId = _a.cardId, teamAccountId = _a.teamAccountId, isDefaultCard = _a.isDefaultCard;
    var _b = __read(React.useState(false), 2), isVisible = _b[0], setIsVisible = _b[1];
    var hidePopOver = function () { return setIsVisible(false); };
    var displayToast = useToast().displayToast;
    var onDeleteCardCompleted = function () {
        displayToast({
            icon: Icon.Types.Check,
            text: PaymentStrings.removePaymentCardSuccess(),
            insetFromEdge: Inset.Sizes.XxxLarge,
        });
    };
    var _c = __read(useDeletePaymentCardMutation(teamAccountId, cardId, onDeleteCardCompleted), 2), deletePaymentMethodByTeamAccount = _c[0], _d = _c[1], isDeletingCard = _d.loading, deleteCardError = _d.error;
    var _e = __read(useSetDefaultPaymentCardMutation(teamAccountId, cardId), 1), setDefaultPaymentMethodForTeamAccount = _e[0];
    var _f = __read(React.useState(false), 2), isDeleteCardModalVisible = _f[0], setIsDeleteCardModalVisible = _f[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Popover, { isVisible: isVisible, interactionType: Popover.InteractionTypes.Controlled, onVisibilityChange: function (newState) { return setIsVisible(newState); }, position: Popover.Positions.BottomRight, content: React.createElement(ListCellContainer, { role: "radiogroup", "data-testid": PaymentCardTestId.ActionMenu },
                React.createElement(Cell, { text: 'Set Default', onClick: function () {
                        setDefaultPaymentMethodForTeamAccount();
                        track(BillingPaymentCardEvents.SET_DEFAULT_CARD_CLICK);
                    }, hidePopOver: hidePopOver, disabled: isDefaultCard, dataTestId: PaymentCardTestId.SetDefaultCardButton }),
                React.createElement(Cell, { text: 'Delete', onClick: function () {
                        setIsDeleteCardModalVisible(true);
                        track(BillingPaymentCardEvents.DELETE_CARD_CLICK);
                    }, hidePopOver: hidePopOver, dataTestId: PaymentCardTestId.DeleteCardButton })) }, function (_a) {
            var describedBy = _a.describedBy;
            return (React.createElement(IconButton, { "data-testid": PaymentCardTestId.ActionButton, accessibilityDescribedBy: describedBy, isDepressed: isVisible, accessibilityLabel: 'Payment Method Options', iconType: Icon.Types.MoreHorizontal, onClick: function () {
                    setIsVisible(!isVisible);
                }, hidePopOver: hidePopOver }));
        }),
        isDeleteCardModalVisible && (React.createElement(RemovePaymentCardModal, { isDeletingCard: isDeletingCard, deleteCardError: deleteCardError === null || deleteCardError === void 0 ? void 0 : deleteCardError.message, onClose: function () { return setIsDeleteCardModalVisible(false); }, deletePaymentMethodByTeamAccount: deletePaymentMethodByTeamAccount }))));
};
export default PaymentCardActionPopover;
var templateObject_1;
